<template>
  <section class="section2-container">
    <div class="title-container pic-full" :class="lang"></div>
    <p class="desc" :class="lang">{{ homeLang.section2.desc }}</p>
    <div class="pic-container pic-full" :class="lang"></div>
  </section>
</template>

<script>
export default {
  name: "section2",
  props: {
    homeLang: {
      type: Object
    }
  },
}
</script>

<style lang="less">
@media screen and (min-width: 767px) {
  .section2-container {
    .title-container {
      &.zh {
        margin: 0.53rem auto 0;
        width: 7.07rem;
        height: 0.58rem;
        background-image: url("../../assets/pc/section2/title_zh.png");
      }
      &.en {
        margin: 0.56rem auto 0;
        width: 7.98rem;
        height: 1.1rem;
        background-image: url("../../assets/pc/section2/title.png");
      }
    }
    .desc {
      width: 9.47rem;
      line-height: 0.28rem;
      font-size: 0.2rem;
      font-family: PingFangSC, PingFangSC-Regular;
      text-align: center;
      color: #333333;
      margin: 0.35rem auto 0;
    }
    .pic-container {
      width: 11.52rem;
      height: 4.88rem;
      background-image: url("../../assets/pc/section2/productionCompare.png");
      margin-top: 0.1rem;
      &.zh {
        background-image: url("../../assets/pc/section2/productionCompare_zh.png");
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .section2-container {
    .title-container {
      &.zh {
        margin: 0.35rem auto 0;
        width: 6.09rem;
        height: 0.5rem;
        background-image: url("../../assets/mobile/section2/title_zh.png");
      }
      &.en {
        margin: 0.35rem auto 0;
        width: 5.81rem;
        height: 0.96rem;
        background-image: url("../../assets/mobile/section2/title.png");
      }
    }
    .desc {
      line-height: 0.33rem;
      font-size: 0.24rem;
      font-family: PingFangSC, PingFangSC-Regular;
      text-align: center;
      color: #333333;
      margin: 0.44rem auto 0;
      width: 6.25rem;
      &.zh {
        margin: 0.26rem auto 0;
      }
    }
    .pic-container {
      width: 7.5rem;
      height: 3.43rem;
      background-image: url("../../assets/mobile/section2/productionCompare.png");
      &.zh {
        background-image: url("../../assets/mobile/section2/productionCompare_zh.png");
      }
    }
  }
}
</style>
